// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"2a4b7b8b","459":"18a692d1"}[chunkId] + ".chunk.css";
};